import { AutoPaymentIcon } from 'components/icons';
import { ButtonActor } from '../../actors';
import { Card, Spacer } from 'components';
import { memo } from 'react';
import classes from 'classnames';
import styles from './ActivePayment.module.scss';

export interface ActivePaymentProps {
  content: {
    activateBtn: string;
    message: string;
    title: string;
  };
  onActiveBtnHandler: () => void;
  cardClassName?: string;
}

export default memo(function ActivePayment({
  content,
  onActiveBtnHandler,
  cardClassName,
}: ActivePaymentProps) {
  return (
    <Card className={classes(styles['card-body'], cardClassName)}>
      <Spacer className={styles['icon-messages-wrapper']}>
        <Spacer width="40px" height="40px">
          <AutoPaymentIcon data-test="css-Image" />
        </Spacer>
        <div className={styles.messages}>
          <div className={styles['title-message']}>
            <span data-test="css-Title">{content.title}</span>
          </div>
          <div className={styles['message']}>
            <span data-test="css-Info">{content.message}</span>
          </div>
        </div>
      </Spacer>
      <ButtonActor
        buttonProps={{
          onClick: onActiveBtnHandler,
          outlined: true,
          dataTest: 'css-Active-Button',
          fill: true,
        }}
        className={styles['btn-wrapper']}
      >
        {content.activateBtn}
      </ButtonActor>
    </Card>
  );
});
